export enum ResourceType {
    Local=0,
    WithArchiveLink=1
}